var PR_LANG2 = String(window.PR_LANG || document.documentElement.lang || 'fr').slice(0, 2).toLowerCase();
var PR_EN = PR_LANG2 === 'en';
// textes traduits : window.PR_T (snippets/pataroc-head.liquid, clés pataroc.js.* des fichiers de langue) ; {nom} = valeur insérée
function T(key, vars) { var s = (window.PR_T && window.PR_T[key]) || ''; if (vars) Object.keys(vars).forEach(function (k) { s = s.split('{' + k + '}').join(vars[k]); }); return s; }
/* Pataroc : comportements des sections maison (panier, tailles, courbes de niveau) */
var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
var EVENTS = null;
function events() { if (!EVENTS) EVENTS = import('@shopify/events').catch(function () { return null; }); return EVENTS; }

/* Ajout au panier : passe par l'événement standard pour que le tiroir panier et la pastille se mettent à jour */
async function addToCart(source, items) {
  var mod = await events();
  var Ev = mod && mod.CartLinesUpdateEvent;
  var sectionIds = $$('cart-items-component').map(function (e) { return e.dataset.sectionId; }).filter(Boolean);
  var qty = items.reduce(function (a, i) { return a + (i.quantity || 1); }, 0);
  var deferred = null;
  if (Ev && Ev.createPromise) {
    try {
      deferred = Ev.createPromise();
      source.dispatchEvent(new Ev({ action: 'add', context: 'product', lines: items.map(function (i) { return { merchandiseId: String(i.id), quantity: i.quantity || 1 }; }), promise: deferred.promise }));
    } catch (e) { deferred = null; }
  }
  var body = { items: items.map(function (i) { return { id: i.id, quantity: i.quantity || 1 }; }) };
  if (sectionIds.length) body.sections = sectionIds.join(',');
  var data = {}, ok = false;
  try {
    var res = await fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    data = await res.json().catch(function () { return {}; });
    ok = res.ok && !data.status;
  } catch (e) { data = { description: T('connect_error') }; }
  var cart = await fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).catch(function () { return null; });
  if (deferred) {
    if (cart) deferred.resolve({ cart: Ev.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'pataroc', sourceId: 'pataroc', itemCount: qty, sections: data.sections, didError: !ok } });
    else deferred.reject(new Error('cart'));
  }
  if (!ok) throw new Error(data.description || data.message || T('add_error'));
  return cart;
}

/* Cartes produit et kits : choix des options -> variante */
function initBuy(scope) {
  $$('[data-pr-product]', scope).forEach(function (card) {
    if (card.dataset.prReady) return; card.dataset.prReady = '1';
    var json = card.querySelector('script[data-variants]');
    var variants = json ? JSON.parse(json.textContent) : [];
    var btn = card.querySelector('[data-pr-add]');
    var msg = card.querySelector('[data-pr-msg]');
    if (!btn) return;
    var label = btn.textContent;
    function values() {
      var vals = [];
      $$('[data-opt]', card).forEach(function (c) {
        var i = +c.dataset.opt;
        if (c.tagName === 'SELECT') vals[i] = c.value;
        else if (c.getAttribute('aria-pressed') === 'true') vals[i] = c.dataset.value;
      });
      return vals;
    }
    function current() {
      var vals = values();
      return variants.find(function (v) { return v.o.every(function (x, i) { return vals[i] === undefined || vals[i] === x; }); });
    }
    function refresh() {
      var v = current();
      btn.disabled = !v || !v.a;
      btn.textContent = !v ? T('unavailable') : (v.a ? label : T('sold_out'));
      $$('[data-sw-label]', card).forEach(function (l) {
        var on = card.querySelector('[data-opt="' + l.dataset.swLabel + '"][aria-pressed="true"]');
        if (on) l.textContent = on.dataset.value;
      });
    }
    card.addEventListener('change', function (e) { if (e.target.matches('[data-opt]')) refresh(); });
    card.addEventListener('click', function (e) {
      var sw = e.target.closest('button[data-opt]');
      if (sw) {
        $$('button[data-opt="' + sw.dataset.opt + '"]', card).forEach(function (b) { b.setAttribute('aria-pressed', String(b === sw)); });
        refresh();
      }
    });
    btn.addEventListener('click', async function () {
      var v = current(); if (!v || !v.a) return;
      btn.disabled = true; if (msg) msg.hidden = true;
      try {
        await addToCart(btn, [{ id: v.id, quantity: 1 }]);
        btn.classList.add('is-added'); btn.textContent = T('added');
        setTimeout(function () { btn.classList.remove('is-added'); refresh(); }, 1800);
      } catch (err) {
        if (msg) { msg.textContent = err.message; msg.hidden = false; }
        refresh();
      }
    });
    refresh();
  });
}

/* Filtres du catalogue */
function initFilters(scope) {
  $$('[data-pr-filters]', scope).forEach(function (bar) {
    if (bar.dataset.prReady) return; bar.dataset.prReady = '1';
    var sec = bar.closest('.pr') || document;
    var key = 'pr-fam';
    function apply(tag) {
      $$('[data-tag]', bar).forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.tag === tag)); });
      var shown = 0;
      $$('[data-tags]', sec).forEach(function (c) {
        var ok = tag === 'all' || (' ' + c.dataset.tags + ' ').indexOf(' ' + tag + ' ') > -1;
        c.hidden = !ok; if (ok) shown++;
      });
      var empty = sec.querySelector('.pr-grid__empty'); if (empty) empty.hidden = shown > 0;
    }
    var start = 'all';
    try { var s = localStorage.getItem(key); if (s && bar.querySelector('[data-tag="' + s + '"]')) start = s; } catch (e) {}
    apply(start);
    bar.addEventListener('click', function (e) {
      var b = e.target.closest('[data-tag]'); if (!b) return;
      apply(b.dataset.tag);
      try { localStorage.setItem(key, b.dataset.tag); } catch (err) {}
    });
  });
}

/* Guide des tailles */
function initSizes(scope) {
  $$('[data-pr-sizes]', scope).forEach(function (sec) {
    if (sec.dataset.prReady) return; sec.dataset.prReady = '1';
    var G = JSON.parse(sec.querySelector('script[data-guides]').textContent);
    var keys = Object.keys(G);
    var q = function (s) { return sec.querySelector(s); };
    var tabs = q('[data-tabs]'), input = q('[data-measure]'), out = q('[data-result]'), tbody = q('[data-table]');
    var gkey = keys[0];
    try { var p = new URLSearchParams(location.search).get('g'); if (p && keys.indexOf(p) > -1) gkey = p; } catch (e) {}
    var fr = function (n) { return PR_EN ? String(n) : String(n).replace('.', ','); };
    function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function renderTabs() {
      tabs.innerHTML = keys.map(function (k) { return '<button class="pr-tab" role="tab" type="button" aria-selected="' + (k === gkey) + '" data-g="' + k + '">' + esc(G[k].label) + '</button>'; }).join('');
    }
    function setGuide(k) {
      gkey = k; var g = G[k]; renderTabs();
      q('[data-measure-label]').textContent = g.measure; q('[data-th]').textContent = g.th; q('[data-help]').textContent = g.help;
      // colonne « poids » masquée quand elle ne dit rien (ceinture), titre « exemples » propre à chaque produit
      var noKg = g.rows.every(function (s) { return !s.kg || s.kg === '—'; });
      sec.classList.toggle('pr-sizes--nokg', noKg);
      q('[data-exh]').textContent = g.exh || q('[data-exh]').dataset.default;
      var note = q('[data-note]'); if (note) note.textContent = g.note || note.dataset.default;
      input.value = ''; input.placeholder = T('eg') + fr(g.def);
      tbody.innerHTML = g.rows.map(function (s) { return '<tr data-s="' + s.s + '"><td>' + s.s + '</td><td class="cm">' + fr(s.lo) + '–' + fr(s.hi) + ' cm</td><td class="kg">' + esc(s.kg) + '</td><td class="ex">' + esc(s.ex) + '</td></tr>'; }).join('');
      sizeFor();
    }
    function sizeFor() {
      var g = G[gkey], rows = g.rows, c = parseFloat(String(input.value).replace(',', '.'));
      $$('tr', tbody).forEach(function (r) { r.classList.remove('hit'); });
      if (!c) { out.innerHTML = T('enter_measure'); return; }
      if (c < rows[0].lo) { out.innerHTML = T('too_small', { contact: ROOT + 'pages/contact' }); return; }
      if (c > rows[rows.length - 1].hi) { out.innerHTML = T('too_big', { contact: ROOT + 'pages/contact' }); return; }
      var fits = rows.filter(function (s) { return c >= s.lo && c <= s.hi; });
      var pick = fits[fits.length - 1];
      var tr = tbody.querySelector('tr[data-s="' + pick.s + '"]'); if (tr) tr.classList.add('hit');
      out.innerHTML = T('size_result', { s: pick.s, c: fr(c), for: esc(g.for), between: fits.length > 1 ? T('between') : '' });
    }
    tabs.addEventListener('click', function (e) { var b = e.target.closest('[data-g]'); if (b) setGuide(b.dataset.g); });
    input.addEventListener('input', sizeFor);
    q('form').addEventListener('submit', function (e) { e.preventDefault(); sizeFor(); });
    setGuide(gkey);
  });
}

/* Tableau des tailles replié sous le choix de taille (snippet pr-guide-tailles, 28/10) : le lien « Quelle taille choisir ? » l'ouvre sur place
   au lieu de faire défiler la page, et la ligne de la taille choisie suit le clic tout de suite (le rendu serveur du sélecteur la confirme ensuite). */
function initGuide() {
  if (document.body.dataset.prGuide) return; document.body.dataset.prGuide = '1';
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-pr-guide-open]'); if (!a) return;
    var sec = a.closest('.shopify-section') || document;
    var all = $$('details.pr-guide', sec); if (!all.length) return;
    e.preventDefault();
    all.forEach(function (d) { d.open = true; });
    all[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
    var s = all[0].querySelector('summary'); if (s) setTimeout(function () { s.focus({ preventScroll: true }); }, 450);
  });
  document.addEventListener('change', function (e) {
    var el = e.target, vp = el && el.closest && el.closest('variant-picker'); if (!vp) return;
    var name = el.dataset.optionName, val = el.value;
    if (el.tagName === 'SELECT') { var o = el.options[el.selectedIndex]; name = o && o.dataset.optionName; }
    if (!name) return;
    $$('details.pr-guide', vp).forEach(function (d) {
      if (d.dataset.option !== name) return;
      $$('tbody tr', d).forEach(function (tr) { var on = tr.dataset.size === val; tr.classList.toggle('is-on', on); if (on) tr.setAttribute('aria-current', 'true'); else tr.removeAttribute('aria-current'); });
    });
  });
}

/* Date de livraison estimée */
function addBiz(d, n) { var x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); if (x.getDay() !== 0 && x.getDay() !== 6) n--; } return x; }
function initEta(scope) {
  $$('[data-pr-eta]', scope).forEach(function (el) {
    // livraison standard depuis la commande : préparation 1 à 2 jours + 8 à 16 jours ouvrés (CGV art. 6), soit 9 à 18 jours
    var now = new Date();
    var a = addBiz(now, +(el.dataset.min || 9)), b = addBiz(now, +(el.dataset.max || 18));
    var f = function (d) { return d.toLocaleDateString(PR_EN ? 'en-GB' : (PR_LANG2 === 'fr' ? 'fr-FR' : PR_LANG2), { day: 'numeric', month: 'long' }); };
    el.textContent = T('eta', { a: f(a), b: f(b), x: el.dataset.express || '' });
  });
}

/* Courbes de niveau */
function noise(x, y, seed) { return Math.sin(x * 1.7 + seed) * Math.cos(y * 1.3 - seed * 0.7) + 0.55 * Math.sin((x + y) * 2.9 + seed * 2.1) + 0.3 * Math.cos(x * 4.3 - y * 3.1 + seed); }
function drawContours(cv) {
  var r = cv.getBoundingClientRect(); if (!r.width || !r.height) return;
  var o = { scale: +(cv.dataset.scale || 150), seed: +(cv.dataset.seed || 2.2), gap: +(cv.dataset.gap || 0.2), trail: cv.dataset.trail === '1' };
  var dpr = Math.min(2, window.devicePixelRatio || 1);
  cv.width = Math.max(1, r.width * dpr); cv.height = Math.max(1, r.height * dpr);
  var ctx = cv.getContext('2d'); ctx.setTransform(dpr, 0, 0, dpr, 0, 0); ctx.clearRect(0, 0, r.width, r.height);
  var css = getComputedStyle(document.documentElement);
  var col = css.getPropertyValue('--pr-contour').trim() || 'rgba(23,32,27,.1)';
  var step = 14, cols = Math.ceil(r.width / step) + 1, rows = Math.ceil(r.height / step) + 1, sc = o.scale, f = [];
  for (var j = 0; j < rows; j++) { var row = []; for (var i = 0; i < cols; i++) row.push(noise(i * step / sc, j * step / sc, o.seed)); f.push(row); }
  for (var lv = -1.6; lv <= 1.6; lv += o.gap) {
    var major = Math.abs((lv / o.gap) % 4) < 0.01; ctx.strokeStyle = col; ctx.globalAlpha = major ? 1 : 0.7; ctx.lineWidth = major ? 1.4 : 0.9; ctx.beginPath();
    for (var y = 0; y < rows - 1; y++) for (var x = 0; x < cols - 1; x++) {
      var a = f[y][x], b = f[y][x + 1], c = f[y + 1][x + 1], d = f[y + 1][x], px = x * step, py = y * step, pts = [];
      var e = function (v1, v2, x1, y1, x2, y2) { var t = (lv - v1) / (v2 - v1); pts.push([x1 + (x2 - x1) * t, y1 + (y2 - y1) * t]); };
      if ((a < lv) !== (b < lv)) e(a, b, px, py, px + step, py);
      if ((b < lv) !== (c < lv)) e(b, c, px + step, py, px + step, py + step);
      if ((c < lv) !== (d < lv)) e(c, d, px + step, py + step, px, py + step);
      if ((d < lv) !== (a < lv)) e(d, a, px, py, px, py + step);
      for (var k = 0; k + 1 < pts.length; k += 2) { ctx.moveTo(pts[k][0], pts[k][1]); ctx.lineTo(pts[k + 1][0], pts[k + 1][1]); }
    }
    ctx.stroke();
  }
  ctx.globalAlpha = 1;
  if (o.trail) {
    ctx.strokeStyle = css.getPropertyValue('--pr-blaze').trim() || '#C2291F'; ctx.lineWidth = 2.5; ctx.setLineDash([7, 6]); ctx.beginPath();
    ctx.moveTo(r.width * 0.34, r.height * 0.70); ctx.bezierCurveTo(r.width * 0.42, r.height * 0.56, r.width * 0.50, r.height * 0.62, r.width * 0.62, r.height * 0.44);
    ctx.bezierCurveTo(r.width * 0.72, r.height * 0.30, r.width * 0.84, r.height * 0.34, r.width * 0.94, r.height * 0.14); ctx.stroke(); ctx.setLineDash([]);
  }
}
var RO = 'ResizeObserver' in window ? new ResizeObserver(function (entries) { entries.forEach(function (en) { drawContours(en.target); }); }) : null;
function initContours(scope) {
  $$('canvas[data-pr-contours]', scope).forEach(function (cv) {
    if (cv.dataset.prReady) return; cv.dataset.prReady = '1';
    /* ResizeObserver dessine dès l'observation : un seul tracé au lieu de deux (lecture puis écriture du canvas, répétées) */
    if (RO) RO.observe(cv); else drawContours(cv);
  });
}

/* Barre d'achat mobile : masquée quand la section kits est visible */
function initMbar(scope) {
  $$('[data-pr-mbar]', scope).forEach(function (bar) {
    if (bar.dataset.prReady) return; bar.dataset.prReady = '1';
    /* masquée tant que la bannière d'accueil (et ses boutons) est visible, puis près des kits et du pied de page */
    var watch = [document.querySelector(bar.dataset.prMbar), document.querySelector('.pr-hero'), document.querySelector('.pr-footer, footer'), document.querySelector('.pr-news')].filter(Boolean);
    if (!('IntersectionObserver' in window)) return;
    bar.classList.add('is-hidden');
    var seen = new Set();
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) seen.add(e.target); else seen.delete(e.target); });
      var hidden = seen.size > 0;
      bar.classList.toggle('is-hidden', hidden);
      document.documentElement.classList.toggle('pr-mbar-on', !hidden);
    });
    watch.forEach(function (el) { io.observe(el); });
  });
}

/* Apparition douce des blocs au défilement */
var REVEAL = '.pr-grid--rail, .pr-sec-head, .pr-trust__item, .pr-use, .product-grid__item, .pr-banner__content > *, .pr-kit, .pr-card, .pr-promise, .pr-step, .pr-faq details, .pr-news .pr-wrap > *, .pr-size-grid, .pr-steps-cta';
var RIO = ('IntersectionObserver' in window && !(window.Shopify && window.Shopify.designMode) && !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches))
  ? new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { var t = e.target; t.classList.add('pr-in'); RIO.unobserve(t); setTimeout(function () { t.style.transitionDelay = ''; }, 600); } }); }, { rootMargin: '0px 0px 25% 0px' }) : null;
/* images sous la ligne de flottaison (kits, catalogue, « Choisis ta sortie », cartes du méga-menu) : le HTML porte
   data-pr-src / data-pr-srcset et le navigateur ne demande rien ; l'image est branchée à 400 px de l'écran (ou à
   l'ouverture du menu). Sans IntersectionObserver, tout est branché tout de suite ; sans JS, <noscript> affiche l'image. */
var LIO = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
  es.forEach(function (e) { if (e.isIntersecting) { LIO.unobserve(e.target); lazyLoad(e.target); } });
}, { rootMargin: '400px 0px' }) : null;
function lazyLoad(img) {
  var pic = img.parentElement;
  if (pic && pic.tagName === 'PICTURE') $$('source[data-pr-srcset]', pic).forEach(function (s) { s.srcset = s.dataset.prSrcset; s.removeAttribute('data-pr-srcset'); });
  if (img.dataset.prSrcset) { img.srcset = img.dataset.prSrcset; img.removeAttribute('data-pr-srcset'); }
  if (img.dataset.prSrc) { img.src = img.dataset.prSrc; img.removeAttribute('data-pr-src'); }
  // la 2e photo (survol) d'une carte du catalogue est cachée : on la branche avec la 1re
  var alt = img.parentElement && img.parentElement.querySelector('.pr-card__alt[data-pr-src]');
  if (alt && alt !== img) lazyLoad(alt);
}
/* fond de page (photo) : demandé au premier geste du visiteur ou 3 s après le chargement, jamais avant la photo d'accueil */
function initBg() {
  var h = document.documentElement; if (h.classList.contains('pr-bg-on')) return;
  var evs = ['scroll', 'touchstart', 'pointermove', 'keydown'], on = function () { evs.forEach(function (e) { window.removeEventListener(e, on); }); h.classList.add('pr-bg-on'); };
  evs.forEach(function (e) { window.addEventListener(e, on, { passive: true }); });
  if (document.readyState === 'complete') setTimeout(on, 3000); else window.addEventListener('load', function () { setTimeout(on, 3000); }, { once: true });
}
/* méga-menu v2 (02/11) : la section « Méga-menu : rubriques » rend, dans des <template data-pr-rub="Titre">, les produits phares
   et la carte éditoriale de chaque entrée ; au premier survol ou focus de l'entrée, on les pose dans le panneau Horizon et on
   branche la photo de fond (jamais au chargement). Le panneau se ferme après un défilement de plus de 80 px. */
function initMega() {
  var hm = document.querySelector('header-menu'); if (!hm || hm.dataset.prMega) return; hm.dataset.prMega = '1';
  var data = document.querySelector('[data-pr-mega-data]');
  function tpl(title) { if (!data) return null; var ts = data.querySelectorAll('template[data-pr-rub]'); for (var i = 0; i < ts.length; i++) if (ts[i].dataset.prRub.trim() === title) return ts[i]; return null; }
  // photo carrée choisie pour le tiroir du téléphone (remplace la photo du thème avant son chargement)
  $$('.menu-drawer .pr-drawer__pic[data-pr-title]').forEach(function (pic) { var tp = tpl(pic.dataset.prTitle.trim()), img = pic.querySelector('img'); if (tp && tp.dataset.tel && img && img.dataset.prSrc) img.dataset.prSrc = tp.dataset.tel; });
  function arm(e) {
    var li = e.target && e.target.closest ? e.target.closest('.menu-list__list-item') : null; if (!li || li.dataset.prArmed) return;
    var sub = li.querySelector('.menu-list__submenu'); if (!sub) return; li.dataset.prArmed = '1';
    var titleEl = li.querySelector('.menu-list__link-title'), title = titleEl ? titleEl.textContent.trim() : '';
    var tp = tpl(title), inner = sub.querySelector('.menu-list__submenu-inner'), grid = sub.querySelector('.mega-menu__grid');
    if (tp && grid) {
      if (tp.dataset.veil) sub.style.setProperty('--pr-veil', tp.dataset.veil);
      var frag = tp.content.cloneNode(true);
      if (frag.querySelector('.pr-mega2__content')) $$('.mega-menu__content', grid).forEach(function (el) { el.remove(); });
      grid.appendChild(frag); initLazy(grid);
    }
    var url = (tp && tp.dataset.bg) || sub.dataset.prBg; sub.removeAttribute('data-pr-bg');
    if (!inner || !url) return;
    var im = new Image(); im.onload = function () { inner.style.setProperty('--pr-mega-bg', 'url("' + url + '")'); inner.classList.add('pr-mega2--ready'); }; im.src = url;
  }
  hm.addEventListener('pointerenter', arm, true); hm.addEventListener('focusin', arm);
  var y0 = null;
  function onScroll(e) {
    if (hm.getAttribute('aria-expanded') !== 'true') { y0 = null; return; }
    var y = e.target === document ? window.scrollY : e.target.scrollTop;
    if (y0 === null) { y0 = y; return; }
    if (Math.abs(y - y0) > 80) { y0 = null; hm.deactivate({ target: hm, relatedTarget: null, type: 'scroll' }); }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  var pw = document.querySelector('.page-wrapper'); if (pw) pw.addEventListener('scroll', onScroll, { passive: true });
}
function initLazy(scope) {
  // police manuscrite de la boîte à idées : activée quand la boîte approche (sinon police de secours)
  var idee = document.querySelector('.pr-idee');
  if (idee && !document.documentElement.classList.contains('pr-idee-on')) {
    if (LIO) { var io = new IntersectionObserver(function (es) { if (es.some(function (e) { return e.isIntersecting; })) { document.documentElement.classList.add('pr-idee-on'); io.disconnect(); } }, { rootMargin: '400px 0px' }); io.observe(idee); }
    else document.documentElement.classList.add('pr-idee-on');
  }
  $$('img[data-pr-src], img[data-pr-srcset]', scope).forEach(function (img) {
    if (img.dataset.prLz) return; img.dataset.prLz = '1';
    if (LIO) LIO.observe(img); else lazyLoad(img);
  });
}
function initReveal(scope) {
  if (!RIO) return;
  document.documentElement.classList.add('pr-anim');
  $$(REVEAL, scope).forEach(function (el) {
    if (el.dataset.prRv) return;
    if (el.matches('.pr-card') && el.closest('[data-pr-rail]')) return;
    el.dataset.prRv = '1';
    /* décalage en cascade entre éléments frères (cartes d'une même grille) */
    var i = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
    el.style.transitionDelay = Math.min((i % 6) * 40, 160) + 'ms';
    RIO.observe(el);
  });
}

/* Lien « Gérer les cookies » : rouvre les préférences de la bannière cookies Shopify */
function initCookies(scope) {
  $$('[data-pr-cookies]', scope).forEach(function (btn) {
    if (btn.dataset.prReady) return; btn.dataset.prReady = '1';
    var tries = 0;
    (function check() {
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') { (btn.closest('[data-pr-cookies-wrap]') || btn).hidden = false; return; }
      if (++tries < 20) setTimeout(check, 500);
    })();
    btn.addEventListener('click', function () {
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') window.privacyBanner.showPreferences();
    });
  });
}

/* Bouton « Haut de page » du pied de page */
function initTop(scope) {
  $$('[data-pr-top]', scope).forEach(function (btn) {
    if (btn.dataset.prReady) return; btn.dataset.prReady = '1';
    btn.addEventListener('click', function () {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      scroller().scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
      var skip = document.querySelector('.header-logo, #header-component a');
      if (skip) skip.focus({ preventScroll: true });
    });
  });
}

var PR_REDUCE = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

/* Défilement de la page : sur ordinateur (≥ 990 px), Horizon fait défiler .page-wrapper et non la fenêtre */
var PR_SQUEEZE = window.matchMedia ? window.matchMedia('(min-width: 990px)') : { matches: false };
function scroller() { return (PR_SQUEEZE.matches && document.querySelector('.page-wrapper')) || document.scrollingElement || document.documentElement; }
function onPageScroll(fn) { document.addEventListener('scroll', fn, { passive: true, capture: true }); }
function offPageScroll(fn) { document.removeEventListener('scroll', fn, { capture: true }); }

/* En-tête qui se réduit : classe sur <html> dès qu'on a défilé de 40 px */
var PR_HEAD_READY = false;
function initHeader() {
  if (PR_HEAD_READY) return; PR_HEAD_READY = true;
  var root = document.documentElement, ticking = false, on = null;
  function update() {
    ticking = false;
    var next = scroller().scrollTop > 40;
    if (next !== on) { on = next; root.classList.toggle('pr-scrolled', next); }
  }
  onPageScroll(function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } });
  if (PR_SQUEEZE.addEventListener) PR_SQUEEZE.addEventListener('change', update);
  /* premier état lu à la prochaine image : lire scrollTop tout de suite forçait une mise en page complète au milieu de l'initialisation (reflow forcé mesuré par PageSpeed) */
  requestAnimationFrame(update);
}

/* Carrousels : boutons précédent / suivant, glisser à la souris, état des boutons */
function initRail(scope) {
  $$('[data-pr-rail]', scope).forEach(function (rail) {
    if (rail.dataset.prReady) return; rail.dataset.prReady = '1';
    var nav = document.querySelector('[data-pr-rail-nav="' + rail.id + '"]');
    var prev = nav && nav.querySelector('[data-pr-rail-prev]');
    var next = nav && nav.querySelector('[data-pr-rail-next]');
    var rtl = getComputedStyle(rail).direction === 'rtl';
    function step() {
      var card = rail.querySelector('.pr-card:not([hidden])');
      var gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
      return card ? card.getBoundingClientRect().width + gap : rail.clientWidth * 0.8;
    }
    function go(dir) { rail.scrollBy({ left: dir * step() * (rtl ? -1 : 1), behavior: PR_REDUCE ? 'auto' : 'smooth' }); }
    function state() {
      var max = rail.scrollWidth - rail.clientWidth - 2, x = Math.abs(rail.scrollLeft);
      if (prev) prev.disabled = x <= 2;
      if (next) next.disabled = x >= max;
      if (nav) nav.hidden = max <= 0;
    }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    rail.addEventListener('scroll', function () { requestAnimationFrame(state); }, { passive: true });
    rail.addEventListener('keydown', function (e) {
      if (e.target !== rail) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); go(rtl ? -1 : 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(rtl ? 1 : -1); }
    });
    /* glisser à la souris (le tactile utilise le défilement natif) */
    var down = false, moved = false, startX = 0, startLeft = 0;
    rail.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      if (e.target.closest('button, select, input, a.pr-add')) return;
      down = true; moved = false; startX = e.clientX; startLeft = rail.scrollLeft;
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > 6) { moved = true; rail.classList.add('is-dragging'); }
      if (moved) rail.scrollLeft = startLeft - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!down) return; down = false;
      if (moved) {
        rail.classList.remove('is-dragging');
        /* évite d'ouvrir un produit au relâchement d'un glisser */
        rail.addEventListener('click', function (ev) { ev.preventDefault(); ev.stopPropagation(); }, { capture: true, once: true });
        setTimeout(function () { moved = false; }, 0);
      }
    });
    /* les filtres masquent des cartes : on revient au début */
    var bar = rail.closest('.pr') && rail.closest('.pr').querySelector('[data-pr-filters]');
    if (bar) bar.addEventListener('click', function () { setTimeout(function () { rail.scrollTo({ left: 0 }); state(); }, 0); });
    /* ResizeObserver appelle state() dès l'observation : pas de lecture de mise en page immédiate */
    if ('ResizeObserver' in window) new ResizeObserver(state).observe(rail); else state();
  });
}

/* Accueil : le panneau du kit s'incline vers la souris, avec un reflet de lumière (souris uniquement) */
function initTilt(scope) {
  if (PR_REDUCE || !(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches)) return;
  $$('.pr-hero__art', scope).forEach(function (art) {
    if (art.dataset.prTilt) return; art.dataset.prTilt = '1';
    var hero = art.closest('.pr-hero') || art, frame = 0, rect = null, x = 0, y = 0;
    function apply() {
      frame = 0;
      if (!rect) return;
      var px = Math.max(-1, Math.min(1, (x - (rect.left + rect.width / 2)) / (rect.width / 2)));
      var py = Math.max(-1, Math.min(1, (y - (rect.top + rect.height / 2)) / (rect.height / 2)));
      art.style.setProperty('--pr-rx', (px * 7).toFixed(2) + 'deg');
      art.style.setProperty('--pr-ry', (py * -6).toFixed(2) + 'deg');
      art.style.setProperty('--pr-px', px.toFixed(3));
      art.style.setProperty('--pr-py', py.toFixed(3));
    }
    hero.addEventListener('pointerenter', function () { rect = art.getBoundingClientRect(); art.classList.add('is-tilting'); });
    hero.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      if (!rect) rect = art.getBoundingClientRect();
      x = e.clientX; y = e.clientY;
      if (!frame) frame = requestAnimationFrame(apply);
    });
    hero.addEventListener('pointerleave', function () {
      rect = null; art.classList.remove('is-tilting');
      ['--pr-rx', '--pr-ry', '--pr-px', '--pr-py'].forEach(function (k) { art.style.removeProperty(k); });
    });
    onPageScroll(function () { rect = null; });
  });
}

/* Fiche produit : bouton « Voir en 3D » → diapositive du modèle du coloris affiché, chargée au clic seulement */
var PR_3D_READY = false;
function init3D() {
  if (PR_3D_READY) return; PR_3D_READY = true;
  // repère commun au modèle et aux photos du même coloris : début du nom de fichier (data-pr-key « harnais-traction-rouge- »),
  // identique dans toutes les langues, contrairement aux textes alternatifs traduits
  function fileOf(img) { return String((img && (img.currentSrc || img.src)) || '').split('?')[0].split('/').pop().toLowerCase(); }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pr-3d]');
    if (!btn) return;
    var gallery = btn.closest('media-gallery');
    var show = gallery && gallery.slideshow;
    if (!show || !show.slides) return;
    var slides = show.slides, cur = slides[show.current];
    var curFile = fileOf(cur && cur.querySelector('img'));
    var models = slides.filter(function (sl) { return sl.querySelector('product-model'); });
    if (!models.length) return;
    var pick = models.filter(function (sl) { var k = sl.querySelector('[data-pr-key]'); k = k && k.getAttribute('data-pr-key'); return k && curFile.indexOf(k) === 0; })[0] || models[0];
    var i = slides.indexOf(pick);
    Promise.resolve(show.select(i, undefined, { animate: !PR_REDUCE })).then(function () {
      var play = pick.querySelector('.deferred-media__poster-button');
      setTimeout(function () { if (play) play.click(); }, PR_REDUCE ? 0 : 350);
    });
  });
  // « réduire les animations » : le modèle ne tourne pas tout seul
  if (PR_REDUCE) document.addEventListener('click', function (e) {
    var pm = e.target.closest('product-model');
    if (!pm) return;
    var tries = 0;
    (function off() { var mv = pm.querySelector('model-viewer'); if (mv) { mv.removeAttribute('auto-rotate'); return; } if (++tries < 40) setTimeout(off, 150); })();
  }, true);
}

/* Animations en boucle (panneau flottant, bande défilante) : en pause hors de l'écran */
function initLoops(scope) {
  if (PR_REDUCE || !('IntersectionObserver' in window)) return;
  var io = initLoops.io || (initLoops.io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { e.target.classList.toggle('pr-offscreen', !e.isIntersecting); });
  }));
  $$('.pr-hero, .pr-marquee', scope).forEach(function (el) {
    if (el.dataset.prLoop) return; el.dataset.prLoop = '1';
    io.observe(el);
  });
}

/* Vidéo d'ambiance de l'accueil : sans « réduire les animations » ni « économie de données » ; version portrait
   sur téléphone (même seuil que la mise en page, 860 px) ; mise en pause hors de l'écran ; bouton pause pour le visiteur */
function initLoopVideos(scope) {
  // Vidéos en boucle des fiches (section pr-video) : la source n'est posée qu'à l'approche de l'écran, après le chargement de la page
  $$('[data-pr-loop-video]', scope).forEach(function (video) {
    if (video.dataset.prReady) return; video.dataset.prReady = '1';
    var conn = navigator.connection || {};
    if (PR_REDUCE || conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '')) return;
    var btn = video.parentElement.querySelector('[data-pr-video-toggle]');
    var userPaused = false;
    function load() { if (!video.src) video.src = video.dataset.src; }
    function play() { if (!video.src) return; var p = video.play(); if (p && p.catch) p.catch(function () {}); }
    video.addEventListener('playing', function () { video.classList.add('is-playing'); }, { once: true });
    if (btn) {
      btn.hidden = false;
      btn.addEventListener('click', function () {
        userPaused = !video.paused;
        if (userPaused) video.pause(); else { load(); play(); }
        btn.setAttribute('aria-pressed', String(userPaused));
        var a = btn.querySelector('[data-pr-label-pause]'), b = btn.querySelector('[data-pr-label-play]');
        if (a) a.hidden = userPaused; if (b) b.hidden = !userPaused;
      });
    }
    function watch() {
      if (!('IntersectionObserver' in window)) { load(); play(); return; }
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { load(); if (!userPaused) play(); } else video.pause(); });
      }, { rootMargin: '200px 0px', threshold: 0.1 }).observe(video);
    }
    if (document.readyState === 'complete') watch();
    else window.addEventListener('load', watch, { once: true });
  });
}
function initHeroVideo(scope) {
  $$('[data-pr-hero-video]', scope).forEach(function (video) {
    if (video.dataset.prReady) return; video.dataset.prReady = '1';
    var conn = navigator.connection || {};
    if (PR_REDUCE || conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '')) return;
    var tel = window.matchMedia && window.matchMedia('(max-width: 860px)').matches;
    var src = (tel && video.dataset.srcMobile) || video.dataset.src;
    var btn = video.parentElement.querySelector('[data-pr-video-toggle]');
    var userPaused = false, visible = true;
    function play() { if (!video.src) return; var p = video.play(); if (p && p.catch) p.catch(function () {}); }
    // la vidéo n'est demandée qu'après le chargement complet de la page : l'image d'accueil reste prioritaire
    function load() { if (video.src) return; video.src = src; if (visible && !userPaused) play(); }
    if (document.readyState === 'complete') setTimeout(load, 300);
    else window.addEventListener('load', function () { setTimeout(load, 300); }, { once: true });
    video.addEventListener('playing', function () { video.classList.add('is-playing'); }, { once: true });
    function setPressed(paused) {
      if (!btn) return;
      btn.setAttribute('aria-pressed', String(paused));
      var a = btn.querySelector('[data-pr-label-pause]'), b = btn.querySelector('[data-pr-label-play]');
      if (a) a.hidden = paused; if (b) b.hidden = !paused;
    }
    if (btn) {
      btn.hidden = false;
      btn.addEventListener('click', function () {
        userPaused = !video.paused ? true : false;
        if (userPaused) video.pause(); else play();
        setPressed(userPaused);
      });
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { visible = e.isIntersecting; if (visible) { if (!userPaused) play(); } else video.pause(); });
      }, { threshold: 0.15 }).observe(video.parentElement);
    } else { play(); }
  });
}

/* Offres de bienvenue : une seule fenêtre à la fois, une fois par visiteur, puis rien pendant 30 jours */
var DAY = 864e5;
function store(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
function sstore(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }
function recent(k, days) { var t = Number(store(k)); return !!t && Date.now() - t < days * DAY; }
var offersReady = false;
function initOffers() {
  var root = document.querySelector('[data-pr-offers]');
  if (!root || offersReady) return;
  offersReady = true;
  var news = root.querySelector('#pr-pop-news'), exit = root.querySelector('#pr-pop-exit'), fab = root.querySelector('[data-pr-fab]');
  var desktop = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
  var design = !!(window.Shopify && window.Shopify.designMode);
  var done = function () { return recent('pr_news_done', 365); };
  var lastFocus = null, startedAt = Date.now();

  /* autre fenêtre ouverte (panier, recherche…) ou bandeau cookies affiché : on attend */
  function busy() {
    if (document.querySelector('dialog[open]')) return true;
    // le bandeau est en position fixe, où offsetParent vaut toujours null : on teste s'il est rendu (display: none après le choix)
    var banner = document.getElementById('shopify-pc__banner');
    return !!(banner && banner.getClientRects().length > 0);
  }
  function open(dlg, force) {
    if (!dlg || dlg.open || (!force && busy())) return false;
    if (force) $$('dialog[open].pr-pop').forEach(function (d) { close(d, true); });
    lastFocus = document.activeElement;
    // sur ordinateur : fenêtre centrée ; sur téléphone : panneau en bas, la page reste utilisable
    if (desktop.matches) dlg.showModal(); else dlg.show();
    requestAnimationFrame(function () { dlg.classList.add('is-in'); });
    // jamais de focus automatique dans le champ e-mail : sur téléphone le clavier s'ouvrirait tout seul, et partout
    // le moindre focus dans le formulaire charge hCaptcha (900 Ko) chez des visiteurs qui ne veulent pas s'inscrire.
    // hCaptcha (protection anti-robots de Shopify) se charge donc au 1er clic ou à la 1re saisie dans le champ.
    var first = desktop.matches ? (dlg.querySelector('[data-pr-copy]') || dlg.querySelector('.pr-pop__close') || dlg) : dlg;
    if (first) first.focus({ preventScroll: true });
    document.documentElement.classList.add('pr-pop-open');
    if (fab) fab.hidden = true;
    sstore('pr_pop_shown', '1');
    return true;
  }
  function close(dlg, silent) {
    if (!dlg || !dlg.open) return;
    dlg.classList.remove('is-in');
    dlg.close();
    document.documentElement.classList.remove('pr-pop-open');
    if (!silent && lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    if (dlg === news && !done() && fab && !recent('pr_fab_hidden', 30)) fab.hidden = false;
  }

  [news, exit].forEach(function (dlg) {
    if (!dlg) return;
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); close(dlg); });
    dlg.addEventListener('keydown', function (e) { if (e.key === 'Escape') { e.preventDefault(); close(dlg); } });
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg && dlg.matches(':modal')) close(dlg); // clic sur le voile
      if (e.target.closest('[data-pr-pop-close]')) close(dlg);
    });
  });
  if (exit) {
    var sw = exit.querySelector('[data-pr-pop-switch]');
    if (sw) sw.addEventListener('click', function () { close(exit, true); open(news, true); });
  }
  var form = news && news.querySelector('[data-pr-pop-form]');
  if (form) form.addEventListener('submit', function () { sstore('pr_pop_submitted', '1'); });

  // retour après l'envoi du formulaire : on montre le code (ou l'erreur)
  var posted = sstore('pr_pop_submitted') === '1' && /customer_posted=true/.test(location.search + location.hash);
  if (news && sstore('pr_pop_submitted') === '1' && (posted || news.querySelector('[data-pr-pop-error]'))) {
    sstore('pr_pop_submitted', '');
    if (news.querySelector('[data-pr-pop-success]')) store('pr_news_done', String(Date.now()));
    setTimeout(function () { open(news, true); }, 400);
    return;
  }

  if (fab) {
    if (!done() && recent('pr_news_seen', 30) && !recent('pr_fab_hidden', 30)) fab.hidden = false;
    fab.querySelector('[data-pr-fab-open]').addEventListener('click', function () { open(news, true); });
    fab.querySelector('[data-pr-fab-hide]').addEventListener('click', function () { fab.hidden = true; store('pr_fab_hidden', String(Date.now())); });
  }
  if (design || done()) return;

  // fenêtre d'inscription : après le délai réglé ou à mi-page, une fois tous les 30 jours
  // sur téléphone, pas d'ouverture automatique sur une fiche produit : elle cacherait le titre et le prix
  var quietPage = !desktop.matches && root.dataset.template === 'product';
  if (news && !quietPage && !recent('pr_news_seen', 30) && !sstore('pr_pop_shown')) {
    var delay = (Number(root.dataset.delay) || 10) * 1000, fired = false, timer = 0, waited = false;
    var tryOpen = function () {
      if (fired) return;
      if (sstore('pr_pop_shown')) { fired = true; offPageScroll(onScroll); return; } // une offre a déjà été vue pendant cette visite
      if (busy()) { waited = true; clearTimeout(timer); timer = setTimeout(tryOpen, 3000); return; }
      // juste après la bannière cookies : on laisse au visiteur le temps de regarder la page avant la 2e fenêtre
      if (waited) { waited = false; clearTimeout(timer); timer = setTimeout(tryOpen, delay); return; }
      fired = true;
      clearTimeout(timer);
      offPageScroll(onScroll);
      if (open(news)) store('pr_news_seen', String(Date.now()));
    };
    var onScroll = function () {
      var el = scroller(), h = el.scrollHeight - el.clientHeight;
      if (h > 0 && el.scrollTop / h >= 0.5) tryOpen();
    };
    timer = setTimeout(tryOpen, delay);
    onPageScroll(onScroll);
    // choix fait dans la bannière cookies (événement Shopify) : on repart du délai complet, pour ne pas enchaîner deux fenêtres
    document.addEventListener('visitorConsentCollected', function () { if (fired) return; clearTimeout(timer); timer = setTimeout(tryOpen, delay); });
  }

  // offre de sortie : ordinateur seulement, souris qui part vers le haut de la fenêtre
  if (exit) {
    document.addEventListener('mouseout', function onOut(e) {
      if (e.relatedTarget || e.clientY > 8 || !desktop.matches) return;
      if (Date.now() - startedAt < 5000 || sstore('pr_pop_shown') || recent('pr_exit_seen', 30) || done()) return;
      if (open(exit)) { store('pr_exit_seen', String(Date.now())); document.removeEventListener('mouseout', onOut); }
    });
  }
}

/* Code promo : copie avec confirmation animée */
var copyReady = false;
function initCopy() {
  if (copyReady) return;
  copyReady = true;
  document.addEventListener('click', async function (e) {
    var btn = e.target.closest('button[data-pr-copy]');
    if (!btn) return;
    var code = btn.dataset.prCopy, ok = false;
    try { await navigator.clipboard.writeText(code); ok = true; } catch (err) {
      // copie de secours, posée dans le bloc du code : dans une fenêtre modale, le reste de la page est inerte
      var ta = document.createElement('textarea'); ta.value = code; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
      btn.parentElement.appendChild(ta); ta.select();
      try { ok = document.execCommand('copy'); } catch (er) { ok = false; }
      ta.remove();
    }
    if (!ok) {
      // dernier recours : le code est sélectionné, prêt à être copié à la main
      var value = btn.parentElement.querySelector('[data-pr-code]');
      if (value) { var range = document.createRange(); range.selectNodeContents(value); var sel = getSelection(); sel.removeAllRanges(); sel.addRange(range); }
      return;
    }
    var label = btn.querySelector('[data-pr-copy-label]'), status = btn.parentElement.querySelector('[data-pr-copy-status]');
    var initial = label.dataset.initial || label.textContent;
    label.dataset.initial = initial;
    label.textContent = btn.dataset.copied || 'Copié';
    if (status) status.textContent = btn.dataset.copiedStatus || '';
    btn.classList.remove('is-copied'); void btn.offsetWidth; btn.classList.add('is-copied');
    clearTimeout(btn._prT);
    btn._prT = setTimeout(function () { btn.classList.remove('is-copied'); label.textContent = initial; if (status) status.textContent = ''; }, 2200);
  });
}

/* Notifications douces (ajout au panier) */
function toast(msg, isError) {
  var region = document.querySelector('[data-pr-toast]');
  if (!region || !msg) return;
  var item = document.createElement('p');
  item.className = 'pr-toast__item' + (isError ? ' pr-toast__item--error' : '');
  item.textContent = msg;
  region.appendChild(item);
  requestAnimationFrame(function () { item.classList.add('is-in'); });
  setTimeout(function () { item.classList.remove('is-in'); setTimeout(function () { item.remove(); }, 400); }, 3200);
}
var cartToastReady = false;
function initCartToast() {
  if (cartToastReady) return;
  cartToastReady = true;
  events().then(function (mod) {
    if (!mod || !mod.StandardEvents) return;
    document.addEventListener(mod.StandardEvents.cartLinesUpdate, function (e) {
      if (e.action && e.action !== 'add') return;
      if (!e.promise || !e.promise.then) return;
      e.promise.then(function (r) {
        if (r && r.detail && r.detail.didError) return;
        // si le tiroir panier s'ouvre, il suffit ; sinon petite confirmation
        setTimeout(function () { if (!document.querySelector('theme-drawer[open], dialog[open] cart-drawer-component')) toast(T('added_to_cart')); }, 450);
      }).catch(function () {});
    });
  });
}

/* Suggestions du panier : ajout en un clic */
var upsellReady = false;
function initUpsell() {
  if (upsellReady) return;
  upsellReady = true;
  document.addEventListener('click', async function (e) {
    var btn = e.target.closest('button[data-pr-upsell]');
    if (!btn || btn.disabled) return;
    btn.disabled = true; btn.setAttribute('aria-busy', 'true');
    try { await addToCart(btn, [{ id: Number(btn.dataset.prUpsell), quantity: 1 }]); }
    catch (err) { toast(err.message, true); }
    finally { btn.disabled = false; btn.removeAttribute('aria-busy'); }
  });
}

/* Mode sombre : bouton de l'en-tête (le thème est posé avant l'affichage dans pataroc-head.liquid) */
var themeReady = false;
function isDark() { return document.documentElement.getAttribute('data-theme') === 'dark'; }
function syncThemeButtons() { var on = isDark() ? 'true' : 'false'; $$('[data-pr-theme-toggle]').forEach(function (b) { b.setAttribute('aria-pressed', on); }); }
function applyTheme(t) {
  document.documentElement.setAttribute('data-theme', t);
  syncThemeButtons();
  $$('canvas[data-pr-contours]').forEach(drawContours);
}
function initTheme() {
  syncThemeButtons();
  if (themeReady) return;
  themeReady = true;
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-pr-theme-toggle]')) return;
    var next = isDark() ? 'light' : 'dark';
    store('pr-theme', next);
    applyTheme(next);
  });
  // même choix dans les autres onglets ouverts
  window.addEventListener('storage', function (e) { if (e.key === 'pr-theme' && (e.newValue === 'dark' || e.newValue === 'light')) applyTheme(e.newValue); });
  // tant que le visiteur n'a rien choisi, on suit le thème du système
  var mq = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)');
  if (mq && mq.addEventListener && !(window.Shopify && window.Shopify.designMode)) mq.addEventListener('change', function (e) {
    var saved = store('pr-theme');
    if (saved !== 'dark' && saved !== 'light') applyTheme(e.matches ? 'dark' : 'light');
  });
}

function init(scope) { initTheme(); initBg(); initLazy(scope); initMega(); initOffers(); initCopy(); initCartToast(); initUpsell(); initBuy(scope); initFilters(scope); initSizes(scope); initGuide(); initEta(scope); initContours(scope); initMbar(scope); initReveal(scope); initCookies(scope); initTop(scope); initHeader(); initRail(scope); initTilt(scope); initLoops(scope); initHeroVideo(scope); initLoopVideos(scope); init3D(); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }); else init(document);
document.addEventListener('shopify:section:load', function (e) { init(e.target); });
if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { $$('canvas[data-pr-contours]').forEach(drawContours); });

/* Animations (agent DA, 2026-10-17) : révélations supplémentaires + fondu au changement de thème. Ajout en fin de fichier, rien d'autre touché. */
(function () {
  if (typeof REVEAL === 'string' && typeof initReveal === 'function') {
    REVEAL += ', .pr-contact__ticket, .pr-contact__card, .pr-404__body > *, .pr-page-head, .pr-rte > h2';
    initReveal(document);
    document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); });
  }
  if (typeof applyTheme === 'function' && !PR_REDUCE) {
    var base = applyTheme, timer = 0;
    applyTheme = function (t) {
      var h = document.documentElement;
      h.classList.add('pr-switching');
      base(t);
      clearTimeout(timer);
      timer = setTimeout(function () { h.classList.remove('pr-switching'); }, 400);
    };
  }
})();


/* Boîte à idées (agent DA, 2026-10-18) : ouverture/fermeture de la fenêtre, e-mail facultatif, retour après envoi. Ajout en fin de fichier, rien d'autre touché. */
(function () {
  var ANON_FALLBACK = 'anonyme@pataroc.fr', lastFocus = null, closing = 0;
  function dlg() { return document.getElementById('pr-idee-dlg'); }
  function openIdee() {
    var d = dlg(); if (!d) return;
    lastFocus = document.activeElement;
    if (!d.open) { try { d.showModal(); } catch (e) { d.setAttribute('open', ''); } }
    document.documentElement.classList.add('pr-idee-open');
    requestAnimationFrame(function () { d.classList.add('is-in'); });
    var f = d.querySelector('[data-pr-idee-error], [data-pr-idee-thanks], textarea');
    if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 60);
  }
  function closeIdee() {
    var d = dlg(); if (!d || !d.open || closing) return;
    closing = 1; d.classList.remove('is-in');
    document.documentElement.classList.remove('pr-idee-open');
    setTimeout(function () { d.close(); closing = 0; if (lastFocus && lastFocus.focus) lastFocus.focus(); }, PR_REDUCE ? 0 : 280);
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-pr-idee-open]')) { e.preventDefault(); openIdee(); return; }
    if (e.target.closest('[data-pr-idee-close]')) { closeIdee(); return; }
    var d = dlg(); if (d && e.target === d) closeIdee(); // clic sur le fond
  });
  function bind(scope) { var d = (scope || document).querySelector ? (scope || document).querySelector('#pr-idee-dlg') : null; if (d && !d.dataset.prIdeeBound) { d.dataset.prIdeeBound = '1'; d.addEventListener('cancel', function (ev) { ev.preventDefault(); closeIdee(); }); } }
  bind(document);
  document.addEventListener('shopify:section:load', function (e) { bind(e.target); });
  // bouton « Une idée ? » : caché en haut de page, visible dès que le visiteur a défilé de quelques dizaines de pixels (même conteneur de défilement que l'en-tête)
  var fabOn = null, fabTick = false;
  function fabUpdate() { fabTick = false; var top = scroller().scrollTop, next = fabOn ? top > 12 : top > 40; if (next !== fabOn) { fabOn = next; $$('.pr-idee-fab').forEach(function (b) { b.classList.toggle('is-in', next); }); } }
  onPageScroll(function () { if (!fabTick) { fabTick = true; requestAnimationFrame(fabUpdate); } });
  document.addEventListener('shopify:section:load', function () { fabOn = null; fabUpdate(); });
  requestAnimationFrame(fabUpdate); // premier état à la prochaine image, sans forcer la mise en page
  // e-mail obligatoire seulement si « prévenez-moi » est coché
  document.addEventListener('change', function (e) {
    var c = e.target.closest('[data-pr-idee-notify]'); if (!c) return;
    var form = c.closest('form'), mail = form && form.querySelector('[data-pr-idee-email]'), wrap = form && form.querySelector('[data-pr-idee-mail]');
    if (!mail) return;
    mail.required = c.checked; if (wrap) wrap.classList.toggle('is-on', c.checked);
    if (c.checked && !mail.value) mail.focus();
  });
  // envoi : Shopify exige une adresse ; sans e-mail, adresse anonyme de la boutique
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-pr-idee-form]'); if (!form) return;
    var mail = form.querySelector('[data-pr-idee-email]');
    if (mail && !mail.value.trim()) mail.value = form.dataset.prIdeeAnon || ANON_FALLBACK;
    sstore('pr_idee_sent', form.id);
    var b = form.querySelector('[type=submit]'); if (b) { b.setAttribute('aria-busy', 'true'); b.style.opacity = '.7'; }
  });
  // retour après l'envoi : fenêtre rouverte sur le merci (ou l'erreur), fiche de la page contact mise en vue
  var sent = sstore('pr_idee_sent');
  if (sent && /contact_posted=true|pr-idee/.test(location.search + location.hash)) {
    sstore('pr_idee_sent', '');
    var f = document.getElementById(sent), d = dlg();
    if (f && d && d.contains(f)) setTimeout(openIdee, 350);
    else if (f) { var t = f.querySelector('[data-pr-idee-thanks], [data-pr-idee-error]'); if (t) setTimeout(function () { t.scrollIntoView({ block: 'center', behavior: PR_REDUCE ? 'auto' : 'smooth' }); t.focus({ preventScroll: true }); }, 200); }
  } else if (sent) sstore('pr_idee_sent', '');
})();

/* Espace client (agent DA, 2026-10-18) : profil gardé sur l'appareil (clé pr-profil:<id>), avatar + « Bonjour … » dans l'en-tête et le menu, page « Mon profil », bienvenue au premier passage connecté. Ajout en fin de fichier, rien d'autre touché. */
(function () {
  var C = window.PR_CUSTOMER || null, AV = ['husky', 'collie', 'labrador', 'berger', 'terrier', 'patte', 'renard', 'chouette', 'cerf', 'ours'];
  function T2(k, v) { var s = (window.PR_T2 && window.PR_T2[k]) || ''; if (v) Object.keys(v).forEach(function (x) { s = s.split(x).join(v[x]); }); return s; }
  function key() { return C ? 'pr-profil:' + C.id : null; }
  function load() { if (!C) return {}; try { return JSON.parse(localStorage.getItem(key()) || '{}') || {}; } catch (e) { return {}; } }
  function save(p) { try { localStorage.setItem(key(), JSON.stringify(p)); } catch (e) {} }
  function esc(s) { return String(s || '').replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function avatarOf(p) { return AV.indexOf(p.avatar) >= 0 ? p.avatar : 'patte'; }
  function nameOf(p) { return String(p.name || (C && C.first_name) || '').trim().slice(0, 40); }
  function hello(p) { var n = nameOf(p), d = String(p.dog || '').trim().slice(0, 30); if (n && d) return T2('hello_both', { __N__: n, __D__: d }); if (n) return T2('hello', { __N__: n }); if (d) return T2('hello_dog', { __D__: d }); return T2('hello_plain'); }
  function useSvg(av) { return '<svg aria-hidden="true" focusable="false"><use href="#pr-av-' + av + '"/></svg>'; }

  /* En-tête : avatar + salut devant le bouton compte ; menu téléphone : même bandeau en tête */
  function header(p) {
    if (!C) return;
    var url = window.PR_PROFILE_URL || '/pages/profil', label = T2('header_profile') || 'Profil';
    var html = '<span class="pr-hello__av">' + useSvg(avatarOf(p)) + '</span><span class="pr-hello__t">' + esc(hello(p)) + '</span>';
    $$('.account-button').forEach(function (host) {
      // l'avatar choisi se pose sur le bouton compte (clic inchangé : menu du compte Shopify) ; le « Bonjour … » devant, sur grand écran
      host.classList.add('pr-has-av');
      var b = host.querySelector(':scope > .pr-hello__badge');
      if (!b) { b = document.createElement('span'); b.className = 'pr-hello__badge'; b.setAttribute('aria-hidden', 'true'); host.appendChild(b); }
      b.innerHTML = useSvg(avatarOf(p));
      var a = host.previousElementSibling && host.previousElementSibling.classList.contains('pr-hello') ? host.previousElementSibling : null;
      if (!a) { a = document.createElement('a'); a.className = 'pr-hello'; a.href = url; host.parentNode.insertBefore(a, host); }
      a.setAttribute('aria-label', label); a.title = label; a.innerHTML = '<span class="pr-hello__t">' + esc(hello(p)) + '</span>';
    });
    drawerHtml = html + '<span class="pr-hello__go">' + esc(label) + ' →</span>'; drawerUrl = url;
    drawer();
  }
  /* Menu téléphone : le composant du tiroir reconstruit son contenu après le chargement, on repose le bandeau à l'ouverture et après « load » */
  var drawerHtml = '', drawerUrl = '';
  function drawer() {
    if (!drawerHtml) return;
    $$('.menu-drawer__navigation').forEach(function (nav) {
      var d = nav.querySelector(':scope > .pr-hello--drawer');
      if (!d) { d = document.createElement('a'); d.className = 'pr-hello pr-hello--drawer'; nav.insertBefore(d, nav.firstChild); }
      d.href = drawerUrl; d.innerHTML = drawerHtml;
    });
  }
  document.addEventListener('toggle', function (e) { if (e.target && e.target.matches && e.target.matches('.menu-drawer-container')) drawer(); }, true);
  window.addEventListener('load', function () { setTimeout(drawer, 400); });

  /* Page « Mon profil » */
  function page(p) {
    var root = document.querySelector('[data-pr-profil]'); if (!root) return;
    var inn = root.querySelector('[data-pr-profil-in]'), out = root.querySelector('[data-pr-profil-out]');
    if (inn && out) { inn.hidden = !C; out.hidden = !!C; }
    var form = root.querySelector('[data-pr-profil-form]');
    if (!C || !form || form.dataset.prReady) return;
    form.dataset.prReady = '1';
    var big = root.querySelector('[data-pr-av-big]'), h1 = root.querySelector('[data-pr-hello]'), line = root.querySelector('[data-pr-about-line]'), cnt = root.querySelector('[data-pr-about-count]');
    var max = +(root.dataset.aboutMax || 140);
    var SIZES = [{ s: 'XS', lo: 38, hi: 46, kg: [3, 8] }, { s: 'S', lo: 46, hi: 56, kg: [8, 15] }, { s: 'M', lo: 56, hi: 68, kg: [15, 25] }, { s: 'L', lo: 68, hi: 80, kg: [25, 35] }, { s: 'XL', lo: 80, hi: 94, kg: [35, 50] }];
    var sizeBox = root.querySelector('[data-pr-size]'), fr = function (n) { return PR_EN ? String(n) : String(n).replace('.', ','); };
    function sizeFor(q) {
      if (!sizeBox) return;
      var d = sizeBox.dataset, c = parseFloat(String(q.chest || '').replace(',', '.')), w = parseFloat(String(q.weight || '').replace(',', '.'));
      sizeBox.classList.remove('pr-size--out');
      if (!sizeBox.dataset.empty) sizeBox.dataset.empty = (sizeBox.querySelector('.pr-size__empty') || {}).textContent || '';
      if (!c) { sizeBox.innerHTML = '<p class="pr-size__empty">' + esc(sizeBox.dataset.empty) + '</p>'; return; }
      var last = SIZES[SIZES.length - 1];
      if (c < SIZES[0].lo || c > last.hi) { sizeBox.classList.add('pr-size--out'); sizeBox.innerHTML = '<p class="pr-size__p"><a href="' + esc(d.contactUrl) + '">' + esc(c < SIZES[0].lo ? d.tSmall : d.tBig) + '</a></p>'; return; }
      var fits = SIZES.filter(function (x) { return c >= x.lo && c <= x.hi; }), pick = fits[fits.length - 1];
      var html = '<div class="pr-size__big"><span class="pr-size__s">' + pick.s + '</span><div><p class="pr-size__t">' + esc(d.tResult.split('__S__').join(pick.s)) + '</p><p class="pr-size__d">' + esc(d.tDetail.split('__C__').join(fr(c)).split('__R__').join(fr(pick.lo) + '–' + fr(pick.hi)).split('__K__').join(pick.kg[0] + '–' + pick.kg[1] + ' kg')) + (fits.length > 1 ? ' ' + esc(d.tBetween) : '') + '</p></div></div>';
      if (w && (w < pick.kg[0] * 0.8 || w > pick.kg[1] * 1.2)) html += '<p class="pr-size__warn">' + esc(d.tWarn) + '</p>';
      html += '<a class="pr-btn pr-btn--sm" href="' + esc(d.harnessUrl) + '">' + esc(d.tCta) + '</a>';
      sizeBox.innerHTML = html;
    }
    function badges() {
      var ul = root.querySelector('[data-pr-badges]'); if (!ul) return;
      var n = Number((C && C.orders) || ul.dataset.orders || 0);
      $$('[data-pr-badge][data-min]', ul).forEach(function (li) {
        var on = n >= Number(li.dataset.min); li.classList.toggle('is-on', on);
        var t = li.querySelector('[data-todo]'), st = li.querySelector('.pr-badge__state');
        if (t) t.textContent = on ? t.dataset.done : t.dataset.todo;
        if (st) st.textContent = on ? st.dataset.done : st.dataset.locked;
      });
    }
    function birthdayLine(q) {
      var nx = root.querySelector('[data-pr-birthday-next]'), pd = root.querySelector('[data-pr-birthday-pending]');
      var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(q.birthday || '');
      if (!m) { if (nx) nx.hidden = true; if (pd) pd.hidden = true; return; }
      var now = new Date(), d = new Date(now.getFullYear(), +m[2] - 1, +m[3]); if (d < new Date(now.getFullYear(), now.getMonth(), now.getDate())) d.setFullYear(now.getFullYear() + 1);
      if (nx) { nx.textContent = (nx.dataset.t || '').split('__DATE__').join(d.toLocaleDateString(PR_EN ? 'en-GB' : (PR_LANG2 === 'fr' ? 'fr-FR' : PR_LANG2), { day: 'numeric', month: 'long' })); nx.hidden = false; }
      if (pd) pd.hidden = !!brevo();
    }
    function paint(q) { if (big) big.innerHTML = useSvg(avatarOf(q)); if (h1) h1.textContent = hello(q); if (line) { var t = [q.breed, q.about].filter(Boolean).join(' · '); line.textContent = t; line.hidden = !t; } sizeFor(q); birthdayLine(q); }
    function read() { var f = new FormData(form); return { avatar: String(f.get('avatar') || ''), name: String(f.get('name') || '').trim(), dog: String(f.get('dog') || '').trim(), breed: String(f.get('breed') || '').trim(), about: String(f.get('about') || '').trim().slice(0, max), chest: String(f.get('chest') || '').trim(), weight: String(f.get('weight') || '').trim(), birthday: String(f.get('birthday') || '').trim() }; }
    badges();
    function count() { if (cnt && form.elements.about) cnt.textContent = form.elements.about.value.length; }
    ['name', 'dog', 'breed', 'about', 'chest', 'weight', 'birthday'].forEach(function (k) { if (form.elements[k] && p[k]) form.elements[k].value = p[k]; });
    var av = form.querySelector('input[name="avatar"][value="' + avatarOf(p) + '"]'); if (av) av.checked = true;
    var saved = store('pr-theme'), th = form.querySelector('input[name="theme"][value="' + (saved === 'dark' || saved === 'light' ? saved : 'auto') + '"]'); if (th) th.checked = true;
    count(); paint(read());
    form.addEventListener('input', function () { count(); paint(read()); });
    form.addEventListener('change', function (e) {
      if (e.target.name !== 'theme') { paint(read()); return; }
      var v = e.target.value;
      if (v === 'auto') { try { localStorage.removeItem('pr-theme'); } catch (x) {} applyTheme(window.matchMedia && matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'); }
      else { store('pr-theme', v); applyTheme(v); }
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault(); var q = read(); save(q); header(q); paint(q); brevoSync(q);
      var ok = root.querySelector('[data-pr-saved]'); if (ok) { ok.hidden = false; clearTimeout(ok._t); ok._t = setTimeout(function () { ok.hidden = true; }, 3200); }
    });
    var rst = root.querySelector('[data-pr-reset]');
    if (rst) rst.addEventListener('click', function () { try { localStorage.removeItem(key()); } catch (x) {} form.reset(); var d = form.querySelector('input[name="avatar"][value="patte"]'); if (d) d.checked = true; count(); paint({}); header({}); });
    $$('[data-pr-lang-pref]', root).forEach(function (a) { a.addEventListener('click', function () { store('pr-lang-pref', a.dataset.prLangPref); }); });
  }

  /* Bienvenue : une fois par client, pas sur la page profil, pas dans l'éditeur, jamais par-dessus une autre fenêtre ou le bandeau cookies */
  function welcome(p) {
    if (!C || (window.Shopify && window.Shopify.designMode)) return;
    var d = document.getElementById('pr-welcome'); if (!d || document.querySelector('[data-pr-profil]')) return;
    var k = 'pr-welcomed:' + C.id; if (store(k)) return;
    var tries = 0;
    function show() {
      var banner = document.getElementById('shopify-pc__banner');
      if (document.querySelector('dialog[open]') || (banner && getComputedStyle(banner).display !== 'none')) { if (++tries < 30) setTimeout(show, 2000); return; }
      store(k, String(Date.now()));
      var t = d.querySelector('[data-pr-welcome-title]'), n = nameOf(p);
      if (t) t.textContent = (t.dataset.template || '').replace(/,?\s*__N__/, n ? ', ' + n : '').replace(/\s+([!?])/g, '\u00a0$1');
      var avb = d.querySelector('[data-pr-av-welcome]'); if (avb) avb.innerHTML = useSvg(avatarOf(p));
      try { d.showModal(); } catch (e) { d.setAttribute('open', ''); }
      requestAnimationFrame(function () { d.classList.add('is-in'); });
      var f = d.querySelector('[data-pr-welcome-go]'); if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 80);
    }
    function close() { d.classList.remove('is-in'); setTimeout(function () { if (d.open) d.close(); }, PR_REDUCE ? 0 : 280); }
    d.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
    d.addEventListener('click', function (e) { if (e.target === d || e.target.closest('[data-pr-welcome-close]')) close(); });
    setTimeout(show, 1500);
  }

  /* Brevo (prêt à brancher) : si le traceur Brevo est chargé sur le site, on identifie le client connecté et on pousse ses attributs ; sinon rien */
  function brevo() {
    if (!window.PR_BREVO_ON) return null;
    var B = window.Brevo;
    if (B && typeof B.push === 'function') return { identify: function (email, attrs) { B.push(['identify', { identifiers: { email_id: email }, attributes: attrs }]); }, track: function (name, email, props) { B.push(['track', name, { email: email }, { data: props || {} }]); } };
    var s = window.sendinblue;
    if (s && typeof s.identify === 'function') return { identify: function (e, a) { s.identify(e, a); }, track: function (n, e, p) { s.track(n, { email: e }, p || {}); } };
    return null;
  }
  function brevoSync(q, extra) {
    var b = brevo(); if (!b || !C || !C.email) return;
    var attrs = { DOG_NAME: q.dog || '', DOG_BREED: q.breed || '', DOG_BIRTHDAY: q.birthday || '', WISHLIST: wishGet().join(',') };
    if (extra) Object.keys(extra).forEach(function (k) { attrs[k] = extra[k]; });
    try { b.identify(C.email, attrs); } catch (e) {}
  }

  /* Liste d'envies : cœurs sur les cartes et la fiche, page « Mes envies » ; gardée sur l'appareil (clé pr-wish) */
  var WKEY = 'pr-wish', HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.3 4.6 13a4.6 4.6 0 0 1 6.5-6.5l.9.9.9-.9a4.6 4.6 0 0 1 6.5 6.5z"/></svg>';
  function wishGet() { try { var a = JSON.parse(localStorage.getItem(WKEY) || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; } }
  function wishSet(a) { try { localStorage.setItem(WKEY, JSON.stringify(a.slice(0, 50))); } catch (e) {} }
  function wishHas(h) { return wishGet().indexOf(h) >= 0; }
  function wishToggle(h) { var a = wishGet(), i = a.indexOf(h); if (i >= 0) a.splice(i, 1); else a.unshift(h); wishSet(a); wishPaint(); wishRender(); if (C) brevoSync(load()); return i < 0; }
  function handleOf(href) { var m = /\/products\/([^/?#]+)/.exec(href || ''); return m ? decodeURIComponent(m[1]) : ''; }
  function wishLabel(on) { var t = window.PR_T3 || {}; return on ? (t.wish_remove || '') : (t.wish_add || ''); }
  function wishPaint() { $$('[data-pr-wish]').forEach(function (b) { var on = wishHas(b.dataset.prWish); b.setAttribute('aria-pressed', on ? 'true' : 'false'); b.setAttribute('aria-label', wishLabel(on)); b.title = wishLabel(on); var t = b.querySelector('.pr-wish-btn__t'); if (t) t.textContent = wishLabel(on); }); }
  function heartBtn(h, page) { var b = document.createElement('button'); b.type = 'button'; b.className = 'pr-wish-btn' + (page ? ' pr-wish-btn--page' : ''); b.dataset.prWish = h; b.innerHTML = HEART + (page ? '<span class="pr-wish-btn__t"></span>' : ''); return b; }
  function hearts() {
    $$('.pr-card, .product-card').forEach(function (card) {
      if (card.querySelector(':scope > .pr-wish-btn') || card.closest('[data-pr-wish-list]')) return;
      var a = card.querySelector('a[href*="/products/"]'), h = a && handleOf(a.getAttribute('href')); if (!h) return;
      card.appendChild(heartBtn(h));
    });
    var P = window.PR_PRODUCT;
    if (P && P.handle && !document.querySelector('.pr-wish-btn--page')) {
      var h1 = document.querySelector('product-information h1, .product-information h1, main h1');
      if (h1) h1.insertAdjacentElement('afterend', heartBtn(P.handle, true));
    }
    wishPaint();
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-pr-wish]'); if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var on = wishToggle(b.dataset.prWish);
    if (on && !PR_REDUCE) { b.classList.remove('is-pop'); void b.offsetWidth; b.classList.add('is-pop'); }
  }, true);
  function money(cents) { try { return new Intl.NumberFormat(PR_EN ? 'en-GB' : (PR_LANG2 === 'fr' ? 'fr-FR' : PR_LANG2), { style: 'currency', currency: 'EUR' }).format(cents / 100); } catch (e) { return (cents / 100).toFixed(2) + ' €'; } }
  var wishCache = {};
  function wishRender() {
    var box = document.querySelector('[data-pr-wish-list]'); if (!box) return;
    var grid = box.querySelector('[data-pr-wish-grid]'), empty = box.querySelector('[data-pr-wish-empty]'), title = box.querySelector('[data-pr-wish-title]'), d = box.dataset, list = wishGet();
    if (title) title.textContent = list.length ? d.tCount.split('__N__').join(list.length) : d.tTitle;
    if (empty) empty.hidden = list.length > 0;
    if (!list.length) { grid.innerHTML = ''; return; }
    Promise.all(list.map(function (h) {
      if (wishCache[h]) return wishCache[h];
      return (wishCache[h] = fetch('/products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }));
    })).then(function (items) {
      // produits disparus (404) : retirés de la liste, le compteur ne compte que les produits affichés
      var dead = list.filter(function (h, i) { return !items[i]; });
      if (dead.length) { wishSet(list.filter(function (h) { return dead.indexOf(h) < 0; })); }
      var shown = items.filter(Boolean).length;
      if (title) title.textContent = shown ? d.tCount.split('__N__').join(shown) : d.tTitle;
      if (empty) empty.hidden = shown > 0;
      var root = (d.root || '/').replace(/\/$/, '');
      grid.innerHTML = items.map(function (p, i) {
        var h = list[i]; if (!p) return '';
        var img = p.featured_image ? (p.featured_image.indexOf('?') > -1 ? p.featured_image + '&width=400' : p.featured_image + '?width=400') : '';
        var url = root + '/products/' + encodeURIComponent(h);
        var html = '<li class="pr-wish__item" data-h="' + esc(h) + '"><div class="pr-wish__pic">' + (img ? '<a href="' + esc(url) + '" tabindex="-1" aria-hidden="true"><img src="' + esc(img) + '" alt="" loading="lazy"></a>' : '') + '<button type="button" class="pr-wish-btn" data-pr-wish="' + esc(h) + '" aria-pressed="true">' + HEART + '</button></div><div class="pr-wish__body"><h3 class="pr-wish__t"><a href="' + esc(url) + '">' + esc(p.title) + '</a></h3><p class="pr-wish__p">' + esc(money(p.price)) + '</p>';
        if (!p.available) {
          html += '<p class="pr-wish__soldout">' + esc(d.tUnavailable) + '</p>';
          if (brevo()) html += '<div class="pr-wish__notify" data-pr-notify="' + esc(h) + '">' + (C && C.email ? '' : '<input type="email" name="email" placeholder="' + esc(d.tEmail) + '" autocomplete="email">') + '<button type="button" class="pr-btn pr-btn--sm" data-pr-notify-go>' + esc(d.tNotify) + '</button><p class="pr-profil__hint">' + esc(d.tConsent) + '</p></div>';
        } else html += '<a class="pr-btn pr-btn--sm" href="' + esc(url) + '">' + esc(d.tView) + '</a>';
        return html + '</div></li>';
      }).join('');
      wishPaint();
    });
  }
  document.addEventListener('click', function (e) {
    var go = e.target.closest('[data-pr-notify-go]'); if (!go) return;
    var wrap = go.closest('[data-pr-notify]'), h = wrap.dataset.prNotify, box = document.querySelector('[data-pr-wish-list]'), b = brevo(); if (!b) return;
    var mail = (C && C.email) || (wrap.querySelector('input') || {}).value || '';
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(mail)) { var inp = wrap.querySelector('input'); if (inp) { inp.focus(); inp.setAttribute('aria-invalid', 'true'); } return; }
    try { b.identify(mail, { WISHLIST_RESTOCK: h }); b.track('restock_request', mail, { handle: h }); } catch (x) {}
    wrap.innerHTML = '<p class="pr-wish__ok">' + esc(box.dataset.tOk) + '</p>';
  });

  /* Carnet de sorties (connecté) : clé pr-sorties:<id> ; badges 100 / 500 km */
  function logKey() { return C ? 'pr-sorties:' + C.id : null; }
  function logGet() { if (!C) return []; try { var a = JSON.parse(localStorage.getItem(logKey()) || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; } }
  function logSet(a) { try { localStorage.setItem(logKey(), JSON.stringify(a.slice(0, 500))); } catch (e) {} }
  function kmTotal(a) { return Math.round(a.reduce(function (s, x) { return s + (Number(x.km) || 0); }, 0) * 10) / 10; }
  function kmBadges(total) {
    $$('[data-pr-badge][data-min-km]').forEach(function (li) {
      var on = total >= Number(li.dataset.minKm); li.classList.toggle('is-on', on);
      var t = li.querySelector('[data-todo]'), st = li.querySelector('.pr-badge__state');
      if (t) t.textContent = on ? t.dataset.done : t.dataset.todo; if (st) st.textContent = on ? st.dataset.done : st.dataset.locked;
    });
  }
  function journal() {
    var box = document.querySelector('[data-pr-log]'); if (!box || !C || box.dataset.prReady) return;
    box.dataset.prReady = '1';
    var d = box.dataset, form = box.querySelector('[data-pr-log-form]'), list = box.querySelector('[data-pr-log-list]'), tot = box.querySelector('[data-pr-log-total]'), nxt = box.querySelector('[data-pr-log-next]'), empty = box.querySelector('[data-pr-log-empty]');
    var fmt = function (n) { return PR_EN ? String(n) : String(n).replace('.', ','); };
    var today = new Date(); form.elements.d.value = today.getFullYear() + '-' + String(today.getMonth() + 1).padStart(2, '0') + '-' + String(today.getDate()).padStart(2, '0'); form.elements.d.max = form.elements.d.value;
    function render() {
      var a = logGet().slice().sort(function (x, y) { return x.d < y.d ? 1 : -1; }), total = kmTotal(a);
      empty.hidden = a.length > 0;
      tot.textContent = a.length ? d.tTotal.split('__KM__').join(fmt(total)).split('__N__').join(a.length) : '';
      nxt.textContent = !a.length ? '' : (total < 100 ? d.tNext.split('__KM__').join(fmt(Math.round((100 - total) * 10) / 10)).split('__B__').join(d.b100) : total < 500 ? d.tNext.split('__KM__').join(fmt(Math.round((500 - total) * 10) / 10)).split('__B__').join(d.b500) : d.tDone);
      list.innerHTML = a.slice(0, 8).map(function (x) { var dt = new Date(x.d + 'T12:00:00'); return '<li class="pr-log__row" data-id="' + esc(x.id) + '"><time datetime="' + esc(x.d) + '">' + esc(isNaN(dt) ? x.d : dt.toLocaleDateString(PR_EN ? 'en-GB' : (PR_LANG2 === 'fr' ? 'fr-FR' : PR_LANG2), { day: 'numeric', month: 'short' })) + '</time><span class="pr-log__tag' + (x.t === 'rando' ? ' pr-log__tag--rando' : '') + '">' + esc(x.t === 'rando' ? d.tHiking : d.tCanicross) + '</span><b>' + esc(fmt(x.km)) + ' km</b><button type="button" class="pr-log__del" data-pr-log-del="' + esc(x.id) + '" aria-label="' + esc(d.tDelete) + '">×</button></li>'; }).join('');
      kmBadges(total);
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault(); var km = parseFloat(String(form.elements.km.value).replace(',', '.')), dd = form.elements.d.value;
      if (!dd || !(km > 0)) { (dd ? form.elements.km : form.elements.d).focus(); return; }
      var a = logGet(); a.unshift({ id: String(Date.now()), d: dd, km: Math.round(km * 10) / 10, t: form.elements.t.value === 'rando' ? 'rando' : 'canicross' }); logSet(a);
      form.elements.km.value = ''; render();
    });
    box.addEventListener('click', function (e) { var b = e.target.closest('[data-pr-log-del]'); if (!b) return; logSet(logGet().filter(function (x) { return x.id !== b.dataset.prLogDel; })); render(); });
    render();
  }

  var p0 = load(); header(p0); page(p0); welcome(p0); hearts(); wishRender(); journal(); kmBadges(kmTotal(logGet()));
  document.addEventListener('pr:brevo', function () { wishRender(); if (C) { brevoSync(load()); var pd = document.querySelector('[data-pr-birthday-pending]'); if (pd) pd.hidden = true; } });
  var heartsTick = 0; new MutationObserver(function () { clearTimeout(heartsTick); heartsTick = setTimeout(hearts, 300); }).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', function () { header(load()); page(load()); hearts(); wishRender(); journal(); });
  window.addEventListener('storage', function (e) { if (C && e.key === key()) header(load()); });
})();
/* Sélecteur de langue à drapeaux (snippets/localization-form.liquid) : une seule liste ouverte à la fois, fermeture au clic dehors et avec Échap */
(function () {
  function closeAll(except) { document.querySelectorAll('details[data-pr-langsel][open]').forEach(function (d) { if (d !== except) d.open = false; }); }
  document.addEventListener('click', function (e) { closeAll(e.target.closest ? e.target.closest('details[data-pr-langsel]') : null); });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var d = document.querySelector('details[data-pr-langsel][open]');
    if (!d) return;
    e.stopPropagation(); d.open = false;
    var s = d.querySelector('summary'); if (s) s.focus();
  }, true);
})();
